import React from 'react';
import Card from '@elementor/ui/Card';
import CardContent from '@elementor/ui/CardContent';
import Typography from '@elementor/ui/Typography';
import { pushDataLayerEvent } from '../helpers';

/**
 * Article Card component - displays a related article as a search result
 * Redesigned to match Figma "Search Result" component
 * Using Elementor UI components
 */
function ArticleCard({ title, url }) {
  return (
    <Card
      className="ft-article-card"
      component="a"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      variant="outlined"
      onClick={() => {
        pushDataLayerEvent({
          section: 'in page',
          element_name: 'more results articles',
          outcome: 'proceeding to article page',
          additional_description: title,
          english_text: title,
          type: 'navigation',
          link_text: title,
          link_url: url,
        });
      }}
      sx={{
        textDecoration: 'none',
        display: 'block',
        borderRadius: 4,
        borderColor: 'divider',
        transition: 'all 0.2s ease',
        '&:hover': {
          boxShadow: 2,
          borderColor: 'primary.main',
        },
      }}
    >
      <CardContent sx={{ p: 2, px: 3, '&:last-child': { pb: 2 }, display: 'flex', flexDirection: 'column', gap: 1 }}>
        {/* Article label */}
        <Typography variant="caption" color="text.secondary">
          Article
        </Typography>

        {/* Title */}
        <Typography 
          variant="body1" 
          fontWeight={700}
          sx={{ 
            color: 'text.primary',
            lineHeight: 1.4,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {title}
        </Typography>

      </CardContent>
    </Card>
  );
}

export default ArticleCard;
